/**
 * @generated SignedSource<<d527ee74c6495d3b078a74f10a7750cf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithIssueTypeConnection_issueTypesFragmentRef$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly avatar: {
        readonly small: string | null | undefined;
      } | null | undefined;
      readonly issueTypeId?: string | null | undefined;
      readonly label: string;
      readonly value: string;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithIssueTypeConnection_issueTypesFragmentRef";
};
export type issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithIssueTypeConnection_issueTypesFragmentRef$key = {
  readonly " $data"?: issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithIssueTypeConnection_issueTypesFragmentRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithIssueTypeConnection_issueTypesFragmentRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithIssueTypeConnection_issueTypesFragmentRef",
  "selections": [
    {
      "concreteType": "JiraIssueTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraIssueType",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": "value",
              "kind": "ScalarField",
              "name": "id"
            },
            {
              "alias": "label",
              "kind": "ScalarField",
              "name": "name"
            },
            {
              "concreteType": "JiraAvatar",
              "kind": "LinkedField",
              "name": "avatar",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "small"
                }
              ]
            },
            {
              "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "issueTypeId"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraIssueTypeConnection"
};

(node as any).hash = "39660377c07394b192f504658c1422f2";

export default node;
